<template>
  <div class="widget-card-content">
    <h2 class="content-title" v-html="title"/>
    <h3 class="content-subtitle">{{subtitle}}</h3>

    <p v-if="text" class="widget-card-description">{{text}}</p>
  </div>
</template>

<script>

export default {
  name: 'WidgetCardRefer',
  props: {
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="stylus" scoped>
.widget-card-content .content-title b {
  color: red;
  font-weight: 900;
}

.content-subtitle {
  font-size: 16px;
  line-height: 22.4px;
  font-weight: 900;
  margin-bottom: 0;
  margin-top: 28px;
  color: #525F66;
  @media (max-width 480px) {
    margin-top: 25px;
  }
}
</style>
